
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Gastric_cancer",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Gastric_cancer.vue